exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gmnoprint a, .gmnoprint span, .gm-style-cc {\r\n    display:none;\r\n}\r\n\r\nimg[src*=\"http://maps.gstatic.com/mapfiles/api-3/images/google4.png\"] {\r\n    display: none;\r\n}\r\n\r\n.contact-msg .alert-error {\r\n    background-color: red;\r\n    color: #fff;\r\n    font-size: 15px;\r\n    left: 20%;\r\n    padding: 50px;\r\n    position: absolute;\r\n    top: 30%;\r\n    width: 60%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/contact-us/contact-us.component.css
// module id = ../../../../../src/app/contact-us/contact-us.component.css
// module chunks = main